import API from 'utils/api';
import { onError } from 'utils/handlers';

const baseURI = '/configuraciones/menu-order/';

/**
 * GET Menu Order (orden visual del sidebar de la entidad del usuario autenticado)
 * @returns {Promise<{menu_structure: object[]}>}
 */
export const getMenuOrder = async () => {
  try {
    const response = await API.get(baseURI);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return { menu_structure: [] };
};

/**
 * POST Menu Order
 * @param {object[]} menuStructure
 * @returns {Promise<object|boolean>}
 */
export const postMenuOrder = async (menuStructure) => {
  try {
    const response = await API.post(baseURI, { menu_structure: menuStructure });
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
